<template>
    <div>
        <div class="form-group">
            <label for="form-mkt-prop-name">{{ $t('Name (backoffice reference)') }}</label>
            <input type="text" name="name" id="form-mkt-prop-name" class="form-control form-control-lg" v-model="message.name" required>
        </div>



        <div class="form-group">
            <label for="form-mkt-prop-channel">{{ $t('Delivery Channel') }}</label>
            <select name="channel" id="form-mkt-prop-channel" class="form-control form-control-lg"
                    :value="message.channel" v-on:change="setChannel($event)" required :readonly="readonly">
                <option value=""></option>
                <option value="email" v-bind:disabled="message.channel !== 'email' && readonly">{{ $t('Email') }}</option>
                <option value="sms" v-bind:disabled="message.channel !== 'sms' && readonly">{{ $t('SMS') }}</option>
            </select>
        </div>

        <div class="form-group">
            <label for="form-mkt-prop-type">{{ $t('Sending Method') }}</label>
            <select name="type" id="form-mkt-prop-type" class="form-control form-control-lg"
                    v-bind:disabled="!message.channel"
                    :value="message.type"
                    v-on:change="setType($event)"
                    required :readonly="readonly">
                <option value=""></option>
                <option value="manual"  v-bind:disabled="message.type !== 'manual' && readonly">{{ $t('Manual') }} ({{ $t('on demand') }})</option>
                <option value="scheduled"  v-bind:disabled="message.type !== 'scheduled' && readonly">{{ $t('Scheduled') }} ({{ $t('at a specific time') }})</option>
                <option value="automatic" v-bind:disabled="message.channel === 'sms' || (message.type !== 'automatic' && readonly)">{{ $t('Automatic') }} ({{ $t('based on events') }})</option>
            </select>
        </div>

      <AutomaticSendParameters v-if="message.type === 'automatic'"
                                 v-model="message.send_parameters"
                                 :automatic-events="automaticEvents"></AutomaticSendParameters>

      <div class="form-group" v-if="message.type === 'automatic' && workflows.length > 0">
        <label for="form-mkt-prop-workflow">{{ $t('Workflow') }}</label>
        <select id="form-mkt-prop-workflow" name="marketing_workflow_id" class="form-control form-control-lg"
                v-model="message.marketing_workflow_id">
          <option value="">{{ $t('No workflow') }}</option>
          <option v-for="workflow in workflows" :key="workflow.id" :value="workflow.id">{{ workflow.name }}</option>
        </select>
      </div>

      <ScheduledSendParameters v-if="message.type === 'scheduled'"
                                 v-model="message.send_parameters"
                                 :timezone="timezone"
                                 :scheduled-types="scheduledTypes"></ScheduledSendParameters>

        <div class="form-group">
            <label for="form-mkt-prop-template">{{ $t('Message template') }}</label>
            <select id="form-mkt-prop-template" name="marketing_message_template_id" class="form-control form-control-lg"
                    :value="message.marketing_message_template_id"
                    v-on:change="setTemplate($event)"
                    v-bind:disabled="templatesAvailable.length === 0 || message.channel === 'sms'" required>
                <option value="" v-if="templatesAvailable.length > 1 ">--- {{ $t('Select a template') }} ---</option>
                <option v-for="t in templatesAvailable" v-bind:key="t.id" :value="t.id">{{ t.name }}</option>
            </select>
        </div>
    </div>
</template>

<script setup>
import AutomaticSendParameters from "./send-parameters/AutomaticSendParameters.vue";
import ScheduledSendParameters from "./send-parameters/ScheduledSendParameters.vue";
import { computed, onMounted, ref } from "vue";

const props = defineProps({
  messageProps : {
    type: Object,
  },
  automaticEvents: {
    type: Array,
  },
  scheduledTypes: {
    type: Array,
  },
  templates: {
    type: Array,
  },
  workflows: {
    type: Array,
    default: () => [],
  },
  readonly: {
    type : Boolean,
    default: false,
  },
  timezone: {
    required: true,
  },
})

const message = ref({
  name: '',
  channel : null,
  type: null,
  send_parameters : {},
  marketing_message_template_id: null,
  marketing_workflow_id: '',
})

const setChannel = (e) => {
  message.value = {
    ...message.value,
    channel: e.target.value,
    type: message.value.channel === 'sms' ? null : message.value.type,
  }
};
const setType = (e) => {
  message.value = {
    ...message.value,
    type: e.target.value,
    send_parameters: {},
    marketing_message_template_id: null,
  }
};
const setTemplate = (e) => {
  message.value = {
    ...message.value,
    marketing_message_template_id: e.target.value
  }
};

const templatesAvailable = computed(() => {
  var event = null
  if (
    message.value.send_parameters !== null
    && message.value.send_parameters.event !== undefined
  )  {
    event =  message.value.send_parameters.event
  }

  if (message.value.channel === null || message.value.type === null) {
    return []
  }
  if (message.value.type !== 'automatic') {
    return props.templates.filter((template) => {
      return template.channel === message.value.channel
        && template.type === message.value.type
    });
  }

  return props.templates.filter((template) => {
    return template.channel === message.value.channel
      && template.type === message.value.type
      && template.events.includes(event)
  });
})

onMounted(() => {
  message.value = {
    ...message.value,
    ...props.messageProps,
    marketing_workflow_id: props.messageProps?.marketing_workflow_id ?? '',
  }
})
</script>